import React, {useState} from 'react';
import { Button, Divider, Layout, Text, Icon, Card } from '@ui-kitten/components';
import { StyleSheet, ScrollView, Dimensions, Image, View, ImageBackground, TouchableOpacity } from 'react-native';
import * as RootNavigation from '../../../root.navigation.js';


const width = Dimensions.get('window').width;
const height = Dimensions.get('window').height;
const condWidth = Number(Dimensions.get('window').width) < 700 ? Dimensions.get('window').width : 700;

//
// const PlusIcon = (props) => (
//   <Icon {...props} name='plus-square-outline' />
// );
export const MiniPCScreen = () => {


  return (

    <ScrollView>
      <View style={styles.container} level='2' >
          <View style={{justifyContent:'space-between', alignItems:'center', paddingHorizontal: 20,  marginTop:35, marginBottom:10, marginHorizontal:10}}>
          <TouchableOpacity onPress={()=>{RootNavigation.navigate('Menu')}}>

            <Image source= {require('../../../assets/logo.png')} style={{width:100, height:100}} />
            </TouchableOpacity>            <Text status='primary' category='h2' style={{textAlign:'center', marginTop:20}}>مینی پی سی</Text>
          </View>
          <View style={{flexDirection:'row', flex:1, paddingHorizontal:20}}>
            <View style={{flex:1, width: width*0.45, margin:4}}>
            <TouchableOpacity onPress={()=>{RootNavigation.navigate('docam')}}>
              <View style={{borderRadius:15, height: width*0.4*3/4, marginVertical:4}}>
                <ImageBackground source= {require('../../../assets/docam.jpg')}  resizeMode={"cover"} style={{...StyleSheet.absoluteFill, overflow: "hidden", borderRadius:20, borderWidth:2, borderColor:'#808080'}}>
                  <Text status='primary' category='h3' style={{marginTop:10, textAlign:'center', backgroundColor:'#ffffffaa'}}>مدل Docam</Text>
                </ImageBackground>
              </View>
              </TouchableOpacity>
              <TouchableOpacity onPress={()=>{RootNavigation.navigate('vzx')}}>
              <View style={{borderRadius:15, height: width*0.4*3/4, marginVertical:4}}>
                <ImageBackground source={require('../../../assets/vzx2.jpg')}  resizeMode={"stretch"} style={{...StyleSheet.absoluteFill, overflow: "hidden", borderRadius:20, borderWidth:2, borderColor:'#808080'}}>
                  <Text status='primary' category='h3' style={{marginTop:10, textAlign:'center', backgroundColor:'#ffffffaa'}}>مدل vzx</Text>
                </ImageBackground>
              </View>
              </TouchableOpacity>
            </View>
            <View style={{borderRadius:15, width: width*0.5, margin:4}}>
            <TouchableOpacity onPress={()=>{RootNavigation.navigate('v4k')}}>
              <View  style={{borderRadius:15, height: width*0.4*4/3, margin:4}}>
                <ImageBackground source={require('../../../assets/v4k.jpg')}  resizeMode={"cover"} style={{...StyleSheet.absoluteFill, overflow: "hidden", borderRadius:20, borderWidth:2, borderColor:'#808080'}}>
                  <Text status='primary' category='h3' style={{marginTop:10, textAlign:'center', backgroundColor:'#ffffffaa'}}>مدل v4k</Text>
                </ImageBackground>
              </View>
              </TouchableOpacity>
            </View>
          </View>
      </View>
      </ScrollView>
  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
    alignItems:'center',
    justifyContent:'flex-start',
    width

  },
});
// <Image source= {require('../../../assets/new_invoice.png')} style={{width:width*0.7, height:width*0.7, marginVertical:25}} />
